module.exports = __webpack_public_path__ + "44882ffe9a4e8f5ee6c91453ceb1818c.svg";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/pages/GamesPageNewLayout/assets/searchIcon.svg
// module id = 1786
// module chunks = 2